
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import './index.css';

import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';

import Home from './pages/Home';
import Login from './pages/Login';
import Cadastro from './pages/Cadastro';
import EsqueciSenha from './pages/EsqueciSenha';
import ResetarSenha from './pages/ResetarSenha';
import Cardapio from './pages/Cardapio';
import Carrinho from './pages/Carrinho';
import Checkout from './pages/Checkout';
import MeusPedidos from './pages/MeusPedidos';
import PedidoDetalhes from './pages/PedidoDetalhes';
import Fidelidade from './pages/Fidelidade';
import Perfil from './pages/Perfil';

import { AdminDashboard, AdminClientes, AdminRelatorios } from './pages/admin/AdminPages';
import AdminPedidos from './pages/admin/Pedidos';
import AdminProdutos from './pages/admin/Produtos';
import AdminRoleta from './pages/admin/Roleta';
import AdminFidelidade from './pages/admin/Fidelidade';
import AdminConfiguracoes from './pages/admin/Configuracoes';
import AdminCredenciais from './pages/admin/Credenciais';
import AdminAdicionais from './pages/admin/Adicionais';
import AdminTaxas from './pages/admin/Taxas';
import AdminCupons from './pages/admin/Cupons';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--bg)' }}><div className="spinner" /></div>;
  return user ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user?.is_admin ? children : <Navigate to="/" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/cardapio" element={<Cardapio />} />
              <Route path="/login" element={<Login />} />
              <Route path="/cadastro" element={<Cadastro />} />
              <Route path="/esqueci-senha" element={<EsqueciSenha />} />
              <Route path="/resetar-senha" element={<ResetarSenha />} />
              <Route path="/carrinho" element={<Carrinho />} />
              <Route path="/checkout" element={<PrivateRoute><Checkout /></PrivateRoute>} />
              <Route path="/pedidos" element={<PrivateRoute><MeusPedidos /></PrivateRoute>} />
              <Route path="/pedidos/:id" element={<PrivateRoute><PedidoDetalhes /></PrivateRoute>} />
              <Route path="/fidelidade" element={<PrivateRoute><Fidelidade /></PrivateRoute>} />
              <Route path="/perfil" element={<PrivateRoute><Perfil /></PrivateRoute>} />
            </Route>

            <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="pedidos" element={<AdminPedidos />} />
              <Route path="produtos" element={<AdminProdutos />} />
              <Route path="adicionais" element={<AdminAdicionais />} />              
              <Route path="taxas" element={<AdminTaxas />} />
              <Route path="cupons" element={<AdminCupons />} />
<Route path="clientes" element={<AdminClientes />} />
              <Route path="roleta" element={<AdminRoleta />} />
              <Route path="fidelidade" element={<AdminFidelidade />} />
              <Route path="relatorios" element={<AdminRelatorios />} />
              <Route path="configuracoes" element={<AdminConfiguracoes />} />
              <Route path="credenciais" element={<AdminCredenciais />} />
            </Route>
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
